import React, { Component } from 'react'
import "../../../../css/general-style.css"
import '../../../../css/table-responsive.css'
import '../../../PreSaleOrdersList.css'
import { NumberFormat } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai'
import PieGraph from '../../../../components/PieGraph';
import DashModalV2 from '../../../../components/DashModalV2';
import { getValueCookie } from '../../../../services/cookieService';

// Same goal-completion color mapping as TableSalesTypeView (2026-09-09 redesign).
function statusColor(colorClass) {
    if (colorClass === 'grayTableCell') return '#EF4444'   // <30% of goal
    if (colorClass === 'yellowTableCell') return '#F59E0B' // 30-99% of goal
    return '#10b981'                                       // >=100% of goal
}

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        Title: '',
        showModal1: false,
        Detail: [],
        Total: 0

    }
    clearStates() {
        this.setState({
            Detail: [],
            Title: '',
            Total: 0
        })
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
        this.clearStates()
    }
    getTotals() {
        let total = 0
        for (const row of this.state.Detail) {
            total += row.NonTaxableSalesAmt
        }
        this.setState({ Total: total })
    }

    async getDetail(detail, title) {
        const arr = Array.isArray(detail) ? detail : []
        const sorted = arr.slice().sort((a, b) => (Number(b.NonTaxableSalesAmt) || 0) - (Number(a.NonTaxableSalesAmt) || 0))
        const MAX = 500
        const limited = sorted.length > MAX ? sorted.slice(0, MAX) : sorted
        const fullTotal = arr.reduce((s, r) => s + (Number(r.NonTaxableSalesAmt) || 0), 0)
        const titleSuffix = sorted.length > MAX ? ` (top ${MAX} of ${sorted.length})` : ''
        await this.setState({ Detail: limited, Title: title + titleSuffix, Total: fullTotal })
        await this.handleModalOpen("showModal1")
    }
    addMonth() {
        if (getValueCookie('TypeUser') === '1') {
            this.props.Father.changeAllMonthData(this.props.SalesPerson, (this.props.Date.setMonth(this.props.Date.getMonth() + 1)))
        }

    }
    restMonth() {
        if (getValueCookie('TypeUser') === '1') {
            this.props.Father.changeAllMonthData(this.props.SalesPerson, (this.props.Date.setMonth(this.props.Date.getMonth() - 1)))
        }
    }


    render() {
        const isAdmin = getValueCookie('TypeUser') === '1';

        return (
            <>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                            </div>
                            <div className='col-sm-12 pb-2'>
                                <div className='pb-2' />

                                {/* Month banner (2026-09-09 redesign, same pattern as
                                    TableSalesTypeView) — nav arrows for admins only. */}
                                <div style={{
                                    background: 'linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(30, 58, 138) 100%)',
                                    borderRadius: '10px', padding: '8px 10px', marginBottom: '12px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                }}>
                                    {isAdmin ? (
                                        <button onClick={() => this.restMonth()} title="Previous month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                            <AiFillCaretLeft />
                                        </button>
                                    ) : <span />}
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem', letterSpacing: '0.5px', textAlign: 'center', flex: 1 }}>{this.props.Month}</span>
                                    {isAdmin ? (
                                        <button onClick={() => this.addMonth()} title="Next month" style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', color: 'white', cursor: 'pointer', width: '28px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
                                            <AiFillCaretRight />
                                        </button>
                                    ) : <span />}
                                </div>

                                {/* Vertical-only scroll — one card per salesperson (2026-09-09
                                    redesign, client's ask: no horizontal scroll). */}
                                <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: '2px' }}>
                                    {this.props.data.Information.map((element, e) => {
                                        const amount = element.Data[0] || {}
                                        return (
                                            <div key={`sp${e}`} className='pol-card' onClick={() => this.getDetail(element.Detail, element.Name)}
                                                style={{ borderLeft: `4px solid ${statusColor(element.Color)}`, padding: '14px 16px', marginBottom: '10px', cursor: 'pointer' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                                    <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>{element.Name}</strong>
                                                    <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(amount.Total))}</strong>
                                                </div>
                                                <div className='pol-card__grid'>
                                                    <div className='pol-kv-box'>
                                                        <span>Percentage</span>
                                                        <strong>{pricesFormat(amount.Percentage)}%</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Goal</span>
                                                        <strong>${NumberFormat(pricesFormat(amount.TotalMeta))}</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Goal Progress</span>
                                                        <strong>{pricesFormat(amount.PercentageComplete)}%</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {this.props.data.Months.map((month, m) => (
                                        <div key={`total${m}`} className='pol-card' style={{ padding: '14px 16px', background: '#F8FAFC' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                                <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>TOTAL</strong>
                                                <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(month.Total))}</strong>
                                            </div>
                                            <div className='pol-card__grid'>
                                                <div className='pol-kv-box'>
                                                    <span>Percentage</span>
                                                    <strong>100%</strong>
                                                </div>
                                                <div className='pol-kv-box'>
                                                    <span>Goal</span>
                                                    <strong>${NumberFormat(pricesFormat(month.TotalMeta))}</strong>
                                                </div>
                                                <div className='pol-kv-box'>
                                                    <span>Goal Progress</span>
                                                    <strong>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='col-sm-12'>
                                <div className='importantNoteContainer'>
                                    <div className='importantNoteColor'></div>
                                    <p className='importantNoteText'>The total sales does not include late invoices, spoilage, discounts and credit notes</p>
                                </div>

                                {this.props.data.Months.map((element, e) => (
                                    <div key={`pie${e}`} style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                        <div className='pt-3' style={{ width: '100%', maxWidth: '520px' }}>
                                            <PieGraph options={element.Options} data={element.DataSet} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <DashModalV2
                    title={'Sales: ' + this.state.Title}
                    subtitle={`Total: $${NumberFormat(pricesFormat(this.state.Total))}`}
                    show={this.state.showModal1}
                    onClose={() => this.handleModalClose('showModal1')}
                >
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean align-middle'>
                            <thead>
                                <tr>
                                    <th>Invoice No</th>
                                    <th>Invoice Type</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Route</th>
                                    <th className='text-end'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Detail.map((order, o) => (
                                    <tr key={o}>
                                        <td>{order.InvoiceNo}</td>
                                        <td className='text-center'>{order.InvoiceType}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{order.UDF_RUTA}</td>
                                        <td className='text-end'>${NumberFormat(pricesFormat(order.NonTaxableSalesAmt))}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr>
                                    <td className='textTableSize fw-bold'>Total</td><td colSpan={4}></td>
                                    <td className='textTableSize text-end fw-bold'>${NumberFormat(pricesFormat(this.state.Total))}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </DashModalV2>

            </>
        )
    }
}
